import React from "react"
import { Box, IconButton, Tooltip } from "@mui/material"
import { useLocation, Link } from "react-router-dom"
import HomeIcon from "@mui/icons-material/Home"

const SiteWrapper = ({ children }) => {
  const location = useLocation()
  const isHomePage = location.pathname === "/" || location.pathname === "/home" || location.pathname === "/new"

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "#07090e",
        color: "#fff",
        position: "relative",
        overflowX: "hidden",
      }}
      className="main-page-wrapper"
    >
      {/* Embedded CSS for floating bg blobs */}
      <style dangerouslySetInnerHTML={{ __html: `
        @keyframes float-slow {
          0% { transform: translateY(0px) scale(1); }
          50% { transform: translateY(-15px) scale(1.05); }
          100% { transform: translateY(0px) scale(1); }
        }
        @keyframes float-reverse {
          0% { transform: translateY(0px) scale(1.05); }
          50% { transform: translateY(15px) scale(1); }
          100% { transform: translateY(0px) scale(1.05); }
        }
        .wrapper-bg-blob-1 {
          animation: float-slow 12s ease-in-out infinite;
        }
        .wrapper-bg-blob-2 {
          animation: float-reverse 15s ease-in-out infinite;
        }
      ` }} />

      {/* Background Container for Blobs (to prevent scrolling) */}
      <Box sx={{ position: "absolute", inset: 0, overflow: "hidden", pointerEvents: "none", zIndex: 0 }}>
        {/* Animated Background Neon Blobs */}
        <Box
          className="wrapper-bg-blob-1"
          sx={{
            position: "absolute",
            width: "500px",
            height: "500px",
            borderRadius: "50%",
            background: "radial-gradient(circle, rgba(99, 102, 241, 0.05) 0%, rgba(0,0,0,0) 70%)",
            top: "-100px",
            left: "10%",
          }}
        />
        <Box
          className="wrapper-bg-blob-2"
          sx={{
            position: "absolute",
            width: "600px",
            height: "600px",
            borderRadius: "50%",
            background: "radial-gradient(circle, rgba(236, 72, 153, 0.04) 0%, rgba(0,0,0,0) 70%)",
            bottom: "-100px",
            right: "10%",
          }}
        />

        {/* Subtle Cyber Grid Overlay */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: `
              linear-gradient(rgba(255, 255, 255, 0.007) 1px, transparent 1px),
              linear-gradient(90deg, rgba(255, 255, 255, 0.007) 1px, transparent 1px)
            `,
            backgroundSize: "60px 60px",
          }}
        />
      </Box>

      {/* Floating Home Button (Visible on all pages except the Home Page) */}
      {!isHomePage && (
        <Tooltip title="Back to Home Portal" placement="right">
          <IconButton
            component={Link}
            to="/"
            sx={{
              position: "fixed",
              top: "24px",
              left: "24px",
              zIndex: 9999,
              color: "#fff",
              border: "1px solid rgba(255, 255, 255, 0.1)",
              background: "rgba(7, 9, 14, 0.6)",
              backdropFilter: "blur(12px)",
              boxShadow: "0 8px 32px rgba(0, 0, 0, 0.3)",
              p: 1.5,
              transition: "all 0.2s ease-in-out",
              "&:hover": {
                background: "rgba(255, 255, 255, 0.1)",
                borderColor: "#6366f1",
                transform: "scale(1.1)",
              },
            }}
          >
            <HomeIcon sx={{ fontSize: "22px" }} />
          </IconButton>
        </Tooltip>
      )}

      {/* Main Content Area */}
      <Box
        component="main"
        sx={{
          position: "relative",
          zIndex: 1,
          minHeight: "100vh",
          // Avoid overlapping the floating home button on sub-pages
          paddingTop: !isHomePage ? { xs: "80px", md: "32px" } : "0px",
        }}
      >
        {children}
      </Box>
    </Box>
  )
}

export default SiteWrapper
